import { LandingPage } from '@features/landing'
import { SERVICE_NAME } from '@shared/constants/service'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/landing')({
  component: LandingPage,
  head: () => ({
    meta: [
      { title: `${SERVICE_NAME} - 당신의 사주를 읽어드릴게요` },
      {
        name: 'description',
        content:
          '정통 명리학 기반 사주팔자 분석. 오행 차트, 월별 운세, 캐릭터 해설까지. 무료로 시작하세요.',
      },
      { property: 'og:title', content: `${SERVICE_NAME} | 당신의 사주를 읽어드릴게요` },
      {
        property: 'og:description',
        content: '3분이면 충분해요. 정통 명리학 기반 나만의 사주 리포트.',
      },
      { property: 'og:type', content: 'website' },
    ],
  }),
})
